export default "__VITE_ASSET__0C3u0Ovk__"